/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Is_Sellable_TextInputs */

const vi_product_is_sellable_text = /** @type {(inputs: Product_Is_Sellable_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cho phép bán lẻ trên POS / đơn hàng`)
};

/**

* @param {Product_Is_Sellable_TextInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_is_sellable_text = /** @type {((inputs?: Product_Is_Sellable_TextInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Is_Sellable_TextInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_is_sellable_text(inputs)
});